import React from 'react';
import colors from '../../theme/colors';

export default function LoadingSpinner() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 40,
      color: colors.textMuted,
      fontSize: 13,
    }}>
      Loading...
    </div>
  );
}
